import React from 'react';
import { Dialog, Button, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useStyles } from '../../../../theme/Modals';
import Preloader from '../../../global/Preloader';
import { toast } from 'react-toastify';
import { useMutation } from '@apollo/client';
import { DELETE_PARTNER_ACCOUNT_EMPLOYEE } from '../../../../actions/delete';

const ModalDeleteMember = ({ show, hideModal, id, query, getVariables }) => {
    const classes = useStyles();

    const [setDeleteAccount, { loading }] = useMutation(DELETE_PARTNER_ACCOUNT_EMPLOYEE);

    const onClickDelete = () => {
        setDeleteAccount({
            variables: {
                id,
            },
            refetchQueries: [{ query: query, variables: getVariables }],
        })
            .then(() => toast.success('Success'))
            .catch(err => toast.error(err.message));
        hideModal();
    };

    if (loading) return <Preloader />;

    return (
        <div>
            <Dialog
                className={classes.dialog}
                maxWidth="md"
                open={show}
                onClose={() => {
                    hideModal();
                }}
            >
                <div className={classes.modal}>
                    <div className={classes.header}>
                        <Typography variant="h1">Delete member</Typography>
                        <Button className={classes.close} onClick={() => hideModal()}>
                            <CloseIcon />
                        </Button>
                    </div>
                    <div className={classes.modalBody}>
                        <div className={classes.dsc}>Are you sure that you want to delete the user id {id}?</div>
                    </div>
                    <div className={classes.modalFooter}>
                        <Button className={classes.cancel} onClick={() => hideModal()}>
                            Cancel
                        </Button>
                        <Button className={classes.delete} onClick={onClickDelete}>
                            Delete
                        </Button>
                    </div>
                </div>
            </Dialog>
        </div>
    );
};

export default ModalDeleteMember;
